import React from 'react'
import { Paper, Typography } from '@mui/material'
import CurtainWithProgress from '../components/CurtainWithProgress'

const LoadingPage = () => {
  return (
    <Paper
      elevation={0}
      sx={{ height: '100vh', width: '100vw', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <Typography variant="body1">資料下載中，請稍候...</Typography>
      <CurtainWithProgress open={true} />
    </Paper>
  )
}

export default LoadingPage